export function getApiErrorMessage(error, fallback = 'Request failed.') {
  const message = error?.response?.data?.message;
  if (message) return message;

  const status = error?.response?.status;
  if (status === 401) return 'Your session has expired. Please sign in again.';
  if (status === 403) return 'You do not have permission to perform this action.';
  if (status === 404) return 'The requested resource was not found.';

  return fallback;
}